// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__7quuN","button":"styles_button__n9OjM","label":"styles_label__434tv","icon":"styles_icon__9Zbyg","text":"styles_text__MpNjX"};